import type { ManagementContactGroupMember } from '#pie/internal/api/pie-bff';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprManagementContactDetailSorting: DefaultSorting<ManagementContactGroupMember> =
  {
    desc: false,
    id: 'name',
  };

export const cprManagementContactDetailSortingAtom = createSortingAtom({
  defaultSorting: defaultCprManagementContactDetailSorting,
});
